<script>
export default {
  data() {
    return {
      links: [
        {text: 'Home', link: '/'},
        {text: 'Work', link: 'work'},
        {text: 'Contact', link: 'contact'}
      ],
    }
  },
  render() {
    return this.$scopedSlots.default({
      links: this.links,
    })
  }


}
</script>

<style>

</style>
